import React from "react";

const Cross = (props) => {
  return (
    <svg
      {...props}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" stroke="none" />
      <path d="M10 10L30 30" stroke="inherit" strokeWidth="2" />
      <path d="M30 10L10 30" stroke="inherit" strokeWidth="2" />
    </svg>
  );
};

export default Cross;
